import gql from 'graphql-tag';

export default gql`
  mutation ($subject: MongoID!, $name: String!, $description: String, $index: Float, $status: EnumContentGroupStatus) {
    createContentGroup(record: { subject: $subject, name: $name, description: $description, index: $index, status: $status }) {
      recordId
    }
  }
`;
